import React from "react";
import axios from "axios";
import { BASE_API_URL } from "../constant";
import OtpInput from 'react-otp-input';
import { useNavigate } from "react-router-dom";
import './BoxInput.css';
import utubelogo from '../images/utubelogo.png';
import { useState, useEffect } from "react";
import AdSenseAds from "./AdSenseAds";


function formatDate(timestamp) {
    function addOrdinalSuffix(day) {
        if (day > 3 && day < 21) return day + 'th';
        switch (day % 10) {
            case 1: return day + 'st';
            case 2: return day + 'nd';
            case 3: return day + 'rd';
            default: return day + 'th';
        }
    }

    const dayWithOrdinal = addOrdinalSuffix(timestamp.getDate());

    // Array of month names
    const monthNames = [
        'JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE',
        'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'
    ];

    // Format the date as "26th August, 2023"
    const formattedDate = `${dayWithOrdinal} ${monthNames[timestamp.getMonth()]}, ${timestamp.getFullYear()}`;

    return formattedDate;
}

function EditUserPredictionNumber() {
    const Navigate = useNavigate();

    const [predictionNumber, setPredictionNumber] = useState('');
    const [yesterdayPredictionNumber, setYesterdayPredictionNumber] = useState('');
    const [yesterdayWinningNumber, setYesterdayWinningNumber] = useState('');
    const [isBefore830PM, setIsBefore830PM] = useState(false);

    const token = localStorage.getItem("token");

    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const handlePredictionWN = async (e) => {
        e.preventDefault();

        if (predictionNumber === "") {
            alert("Please enter a number");
            return;
        }


        await axios.post(BASE_API_URL + "api/winning/user/edit_prediction_number", {
            predictionNumber: predictionNumber,
        }, config).then(() => {
            Navigate("/user/history");
            alert("Prediction Number Updated Successfully");
        }).catch((err) => {
            alert("You can't add or edit prediction number after 8:30 PM.");
            alert(err.response.data.msg);
        });
    };

    useEffect(() => {
        async function fetchData() {
            const token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            await axios.get(BASE_API_URL + "api/winning/user/prediction_number", config).then((res) => {

                function getYesterdayDate() {
                    // const today = new Date();
                    const today = new Date();
                    const yesterday = new Date(today);
                    yesterday.setDate(today.getDate() - 1);

                    const yyyy = yesterday.getFullYear();
                    const mm = String(yesterday.getMonth() + 1).padStart(2, '0');
                    const dd = String(yesterday.getDate()).padStart(2, '0');

                    return `${yyyy}-${mm}-${dd}`;
                }

                // Get yesterday's date as a string
                const yesterdayDate = getYesterdayDate();

                // Filter data to get items with a transaction date matching yesterday
                const yesterdayPredictions = res.data.filter(item => {
                    const itemDate = item.transaction_date.split('T')[0]; // Extract the date portion
                    return itemDate === yesterdayDate;
                });

                // Extract prediction numbers from yesterday's data
                const yesterdayPredictionNumbers = yesterdayPredictions.map(item => item.prediction_number);

                setYesterdayPredictionNumber(yesterdayPredictionNumbers[yesterdayPredictionNumbers.length - 1]);

            }).catch((err) => {
                console.log(err);
            });

            await axios.get(`${BASE_API_URL}api/winning/winning_numbers`)
                .then(res => {
                    const currentDate = new Date();

                    // Subtract one day to get yesterday's date
                    const yesterdayDate = new Date(currentDate);
                    yesterdayDate.setDate(currentDate.getDate() - 1);

                    // Convert both dates to strings and extract only the date part
                    // const currentDateStr = currentDate.toISOString().slice(0, 10);
                    const yesterdayDateStr = yesterdayDate.toISOString().slice(0, 10);

                    let yesterdayWinningNumber = null;

                    // Loop through the data and find yesterday's winning number
                    for (const item of res.data) {
                        if (item.created_date_time.startsWith(yesterdayDateStr)) {
                            yesterdayWinningNumber = item.winning_number;
                            break; // Stop once you find the winning number for yesterday
                        }
                    }
                    setYesterdayWinningNumber(yesterdayWinningNumber);
                })
                .catch(err => {
                    console.log(err);
                });

            // Function to check if the current time is before 8:30 PM
            function checkTime() {
                const currentDate = new Date();
                const currentHour = currentDate.getHours();
                const currentMinute = currentDate.getMinutes();

                // Compare with 20 (8 PM) and 30 (8:30 PM)
                setIsBefore830PM(currentHour < 20 || (currentHour === 20 && currentMinute < 30));
            }

            // Call the checkTime function when the component mounts
            checkTime();

            // Update the time check every minute
            const intervalId = setInterval(checkTime, 60000);

            // Clean up the interval when the component unmounts
            return () => clearInterval(intervalId);
        }
        fetchData();
    }, []);

    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - 1);

    return (
        <div className="bg-secondary text-center">
            {isBefore830PM ?
                <>
                    <div className="bg-white p-3">
                        <h2 className="text-center mb-1">CLICK TO UPDATE YOUR NUMBER</h2>
                        <h6 className="text-center mb-3">FOR {formatDate(new Date())}, DRAW @ 9 PM IST</h6>
                        <form onSubmit={handlePredictionWN}>
                            <div className="form-group mb-3">
                                <div className="otp-digit-input-container">
                                    <OtpInput
                                        value={predictionNumber}
                                        onChange={setPredictionNumber}
                                        numInputs={5}
                                        shouldAutoFocus={true}
                                        inputStyle={{ width: "50px", height: "50px", }}
                                        renderInput={(props) => <input {...props} type="number" />}
                                    />
                                </div>
                            </div>
                            <h6 className="text-success mb-3">terms & conditions apply*</h6>
                            <button type="submit" className="btn btn-success w-50 rounded-pill mb-4">SUBMIT</button>
                        </form>
                        <div className="text-center mb-3">
                            <p className="text-center mb-1">Yesterday's Winning Number ({formatDate(currentDate)}) </p>
                            <h2 style={{ letterSpacing: "0.5em" }} className="text-center ">{yesterdayWinningNumber}</h2>
                        </div>
                        <div className="d-flex justify-content-center mb-5">
                            <div className="bg-secondary border-dark p-1 w-50  text-center rounded-pill mb-1 ">Your prediction <strong>{yesterdayPredictionNumber}</strong></div>
                        </div>

                        <div className="d-flex justify-content-center flex-column mb-3">
                            <div>
                                <img style={{ width: "50px", height: "50px", border: "2px solid black", borderRadius: "100%" }} src={utubelogo} alt="utubelogo" />
                            </div>
                            <p>WATCH THE DRAW VIDEO</p>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center align-items-center flex-column bg-warning p-3">
                        <h3>GET TO WIN</h3>
                        <h2>AMAZING PRIZES !!!</h2>
                        <h4 className="bg-danger border-dark p-2 w-75  text-center text-white rounded-pill mb-1">VIEW LIST OF PRIZES</h4>
                    </div>
                </>
                :
                <div>
                    <h3 className="text-center text-warning mb-3">All entries are closed for today. You can come back and predict for tomorrow after 12 Midnight.</h3>
                </div>
            }
            <AdSenseAds />
        </div>
    )
}

export default EditUserPredictionNumber;